import React from "react";
import styles from "./summaryCell.module.scss";
const SummaryCell = ({ label, value, subline, }) => {
    return (React.createElement("div", { className: styles.cell },
        React.createElement("div", { className: styles.label }, label),
        React.createElement("div", { className: styles.value }, value),
        React.createElement("div", { className: styles.subline }, subline)));
};
export default SummaryCell;
//# sourceMappingURL=SummaryCell.js.map